// src/context/AppVarsContext.js
import { installReportAccessFetch } from '../system/report-access';
import React, { createContext, useState, useEffect } from "react";

// Create the Context
export const AppVarsContext = createContext();

// Create the Provider Component
export const AppVarsProvider = ({ children, appid }) => {
  const [appVars, setAppVars] = useState();
  const [appLoading, setLoading] = useState(true);
  const [appID, setappID] = useState(true);

  // Fetch Application Variables
  const fetchAppVars = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({ appid });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const res = await fetch("https://api.digitalwerks.com/appVars", requestOptions);
      const response = await res.json();

      // Convert the response into a key-value object
      const keyValueObject = response.reduce((acc, item) => {
        acc[item.variable] = item.value;
        return acc;
      }, {});

      document.title = keyValueObject.application;
   //   console.info("appVars", keyValueObject);
      installReportAccessFetch(keyValueObject.api_url);
      setAppVars(keyValueObject);
      setappID(appid);
    } catch (error) {
      console.error("Error fetching app variables:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (appid) {
      fetchAppVars();
    } else {
      console.error("No appid provided to AppProvider");
      setLoading(false);
    }
  }, [appid]);

  return (
    <AppVarsContext.Provider value={{ appVars, appLoading, appID }}>
      {children}
    </AppVarsContext.Provider>
  );
};
